import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const rootGuard: CanActivateFn = () => {
  const router = inject(Router);
  const token = localStorage.getItem('accessToken');

  return token
    ? router.createUrlTree(['/dashboard'])
    : router.createUrlTree(['/login']);
};
